module.exports = __webpack_public_path__ + "img/aghk-truck-selected.5f6b53e5.svg";